import React from "react";
import { Table } from "reactstrap";
// icone
import { FaRankingStar } from "react-icons/fa6";

export default function UserPoints(props) {
  const { nameGuest, pointsGuest } = props;
  return (
    <>
      <div className="div-userPoints">
        <a className="icon-userPoint">
          <FaRankingStar  color="gold" />
        </a>

        <a className="a-user-name">{nameGuest ? nameGuest : "-"}</a>

        <a>
          {pointsGuest ? (
            <div className="div-user-points">
              <a>{pointsGuest}</a>
              <a>Pontos</a>
            </div>
          ) : (
            "-"
          )}
        </a>
      </div>
    </>
  );
}
